import { createSelector } from 'reselect';

const getState = ({ userGroups }) => userGroups;
const getId = (_, id) => id;

const getData = createSelector(getState, ({ data }) => data);
export const getDataById = createSelector(getData, ({ byId }) => byId);
export const getDataByDealerId = createSelector(getData, ({ byDealerId }) => byDealerId);
export const getUserGroupsByDealerId = createSelector(
  getDataById,
  getDataByDealerId,
  getId,
  (dataById, dataByDealerId, dealerId) =>
    /** @type {Array<import('./types/public-user-group').PublicUserGroup>} */ (
      dataByDealerId?.[dealerId]?.map(groupId => dataById?.[groupId] ?? {}) ?? []
    ).sort(({ order: a }, { order: b }) => a - b)
);
export const getUserGroupsByDealerIdInitialValue = createSelector(getUserGroupsByDealerId, data => ({ data }));

const getUi = createSelector(getState, ({ ui }) => ui);
const getSelect = createSelector(getUi, ui => ui.select);

export const getUserGroupById = createSelector(
  getDataById,
  getId,
  (state, userGroupId) => state[userGroupId]
);

export const isFetching = createSelector(getUi, ui => ui.isFetching);
export const isUpdating = createSelector(getUi, ui => ui.isUpdating);
export const getApiError = createSelector(getUi, ui => ui.apiError);
export const getPage = createSelector(getSelect, select => select.page);
export const getSearch = createSelector(getSelect, select => select.search);
export const getLinks = createSelector(getSelect, select => select.links);
